


























































import {Component, Prop, Vue} from "vue-property-decorator";
import RenderProductPrice from "@/components/Shared/RenderProductPrice.vue";
import RenderProductStatus from "@/components/Shared/RenderProductStatus.vue";
import Notification from "@/api/Notification";


@Component({
  components: {RenderProductStatus, RenderProductPrice}
})
export default class NotificationView extends Vue {
  @Prop() private notification!: Notification;

  isAvailable(): boolean {
    if (this.notification.product) {
      return this.notification.product.stockStatus == 1;
    }
    return false;
  }
}
